import { render } from "./ProductsGrid.vue?vue&type=template&id=5cf255d8"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"
script.render = render

export default script